import React, { useState, useEffect, useRef, FC } from 'react'
import { useSelector } from 'react-redux'
import { getGeoLocation } from 'selectors/user/cookie'
import CarouselV2 from 'components/SA/Carousel/v2'
import { ALGOLIA } from '../helpers'
import Polaroid from '../ProductCarouselPolaroid'
import { getArtistSeeMore } from 'apps/saatchi/artdetail2/selectors/carousel'
import SeeMoreTile from '../SeeMoreTile'
import useQA from 'hooks/useQA'
import useCarouselImageLazyLoading from 'components/SA/Carousel/v2/useCarouselImageLazyLoading'
import { fetchSeeMoreArtworks } from 'apps/public/profile/artistProfile/helpers/carousel'
const MIN_ARTWORKS = 5
const LIST_ID = 'see-more-art'
const DATA_API = ALGOLIA

const ArtistArtworksCarousel: FC = () => {
  /* Replacing connector */
  const seeMore = useSelector(getArtistSeeMore)
  const geoLocation = useSelector(getGeoLocation)
  /* ============================================================== */
  const { link, title } = seeMore
  const [artworks, handleArtworks] = useState([])
  const polaroidRef = useRef<HTMLDivElement>(null)
  const [polaroidWidth, setPolaroidWidth] = useState<number>(
    polaroidRef?.current?.offsetWidth || 311
  )
  const { handleImageLazyLoading, lastImageIndexLoaded } = useCarouselImageLazyLoading({
    offset: 5,
  })
  const { testId } = useQA()
  const { destinationZone } = geoLocation
  const LIST_NAME = 'See More Art'
  useEffect(() => {
    fetchSeeMoreArtworks({
      callBack: handleArtworks,
    })
  }, [destinationZone])

  useEffect(() => {
    if (!!polaroidRef?.current?.offsetWidth) {
      setPolaroidWidth(polaroidRef?.current?.offsetWidth)
    }
  }, [polaroidRef?.current?.offsetWidth])

  if (!artworks || artworks.length < MIN_ARTWORKS) {
    return null
  }

  return (
    <div data-section={LIST_ID} {...testId('see-more-artworks')}>
      <CarouselV2
        title={LIST_NAME}
        polaroidWidth={polaroidWidth}
        //customStyle={styles.carouselPolaroidImage}
        onScrollCallback={handleImageLazyLoading}
      >
        {artworks.map((artwork, index) => (
          <Polaroid
            key={index}
            polaroidRef={polaroidRef}
            artwork={artwork}
            //onImageClick={handleClick}
            //onTitleClick={handleClick}
            //showMediumOnMaterial={false}
            index={index}
            listId={LIST_ID}
            listName={LIST_NAME}
            dataApi={DATA_API}
            showArtistName={false}
            isLazyLoading={index > lastImageIndexLoaded}
          />
        ))}
        <SeeMoreTile link={link} title={title} />
      </CarouselV2>
    </div>
  )
}

export default ArtistArtworksCarousel
